/**
 * ARCHON: countries (ISO 3166-1 alpha-2) and state/province lists for the
 * rankings location settings. The server validates codes against its own
 * region map (server/services/rating/regions.js) — keep these in sync.
 */
export const COUNTRIES = [
    ['US', 'United States'],
    ['CA', 'Canada'],
    ['MX', 'Mexico'],
    ['GB', 'United Kingdom'],
    ['DE', 'Germany'],
    ['FR', 'France'],
    ['ES', 'Spain'],
    ['IT', 'Italy'],
    ['NL', 'Netherlands'],
    ['BE', 'Belgium'],
    ['PT', 'Portugal'],
    ['IE', 'Ireland'],
    ['AT', 'Austria'],
    ['CH', 'Switzerland'],
    ['PL', 'Poland'],
    ['CZ', 'Czechia'],
    ['SK', 'Slovakia'],
    ['HU', 'Hungary'],
    ['RO', 'Romania'],
    ['BG', 'Bulgaria'],
    ['GR', 'Greece'],
    ['DK', 'Denmark'],
    ['SE', 'Sweden'],
    ['NO', 'Norway'],
    ['FI', 'Finland'],
    ['IS', 'Iceland'],
    ['EE', 'Estonia'],
    ['LV', 'Latvia'],
    ['LT', 'Lithuania'],
    ['UA', 'Ukraine'],
    ['RU', 'Russia'],
    ['BY', 'Belarus'],
    ['MD', 'Moldova'],
    ['RS', 'Serbia'],
    ['HR', 'Croatia'],
    ['SI', 'Slovenia'],
    ['BA', 'Bosnia and Herzegovina'],
    ['ME', 'Montenegro'],
    ['MK', 'North Macedonia'],
    ['AL', 'Albania'],
    ['XK', 'Kosovo'],
    ['CY', 'Cyprus'],
    ['MT', 'Malta'],
    ['LU', 'Luxembourg'],
    ['LI', 'Liechtenstein'],
    ['MC', 'Monaco'],
    ['AD', 'Andorra'],
    ['SM', 'San Marino'],
    ['BR', 'Brazil'],
    ['AR', 'Argentina'],
    ['CL', 'Chile'],
    ['CO', 'Colombia'],
    ['PE', 'Peru'],
    ['VE', 'Venezuela'],
    ['EC', 'Ecuador'],
    ['BO', 'Bolivia'],
    ['PY', 'Paraguay'],
    ['UY', 'Uruguay'],
    ['GY', 'Guyana'],
    ['SR', 'Suriname'],
    ['PA', 'Panama'],
    ['CR', 'Costa Rica'],
    ['NI', 'Nicaragua'],
    ['HN', 'Honduras'],
    ['SV', 'El Salvador'],
    ['GT', 'Guatemala'],
    ['BZ', 'Belize'],
    ['CU', 'Cuba'],
    ['DO', 'Dominican Republic'],
    ['HT', 'Haiti'],
    ['JM', 'Jamaica'],
    ['TT', 'Trinidad and Tobago'],
    ['BB', 'Barbados'],
    ['BS', 'Bahamas'],
    ['PR', 'Puerto Rico'],
    ['AU', 'Australia'],
    ['NZ', 'New Zealand'],
    ['JP', 'Japan'],
    ['KR', 'South Korea'],
    ['CN', 'China'],
    ['TW', 'Taiwan'],
    ['HK', 'Hong Kong'],
    ['MO', 'Macao'],
    ['SG', 'Singapore'],
    ['MY', 'Malaysia'],
    ['TH', 'Thailand'],
    ['VN', 'Vietnam'],
    ['PH', 'Philippines'],
    ['ID', 'Indonesia'],
    ['IN', 'India'],
    ['PK', 'Pakistan'],
    ['BD', 'Bangladesh'],
    ['LK', 'Sri Lanka'],
    ['NP', 'Nepal'],
    ['MM', 'Myanmar'],
    ['KH', 'Cambodia'],
    ['LA', 'Laos'],
    ['MN', 'Mongolia'],
    ['KZ', 'Kazakhstan'],
    ['UZ', 'Uzbekistan'],
    ['FJ', 'Fiji'],
    ['PG', 'Papua New Guinea'],
    ['GU', 'Guam'],
    ['TR', 'Turkey'],
    ['IL', 'Israel'],
    ['AE', 'United Arab Emirates'],
    ['SA', 'Saudi Arabia'],
    ['QA', 'Qatar'],
    ['KW', 'Kuwait'],
    ['BH', 'Bahrain'],
    ['OM', 'Oman'],
    ['JO', 'Jordan'],
    ['LB', 'Lebanon'],
    ['EG', 'Egypt'],
    ['MA', 'Morocco'],
    ['TN', 'Tunisia'],
    ['DZ', 'Algeria'],
    ['ZA', 'South Africa'],
    ['NG', 'Nigeria'],
    ['KE', 'Kenya'],
    ['GH', 'Ghana'],
    ['ET', 'Ethiopia'],
    ['TZ', 'Tanzania'],
    ['UG', 'Uganda'],
    ['ZW', 'Zimbabwe'],
    ['ZM', 'Zambia'],
    ['BW', 'Botswana'],
    ['NA', 'Namibia'],
    ['MU', 'Mauritius'],
    ['GE', 'Georgia'],
    ['AM', 'Armenia'],
    ['AZ', 'Azerbaijan']
];

export const US_STATES = [
    'Alabama',
    'Alaska',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'District of Columbia',
    'Florida',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming'
];

export const CA_PROVINCES = [
    'Alberta',
    'British Columbia',
    'Manitoba',
    'New Brunswick',
    'Newfoundland and Labrador',
    'Northwest Territories',
    'Nova Scotia',
    'Nunavut',
    'Ontario',
    'Prince Edward Island',
    'Quebec',
    'Saskatchewan',
    'Yukon'
];

export const statesForCountry = (country) => {
    if (country === 'US') {
        return US_STATES;
    }

    if (country === 'CA') {
        return CA_PROVINCES;
    }

    return null;
};

export const countryName = (code) => {
    const entry = COUNTRIES.find(([countryCode]) => countryCode === code);

    return entry ? entry[1] : code;
};
